import { useCallback, useEffect, useState, useMemo } from "react";
import { getCalenderEventList } from "../services/workspace/holiday.service";
import toast from "react-hot-toast";

const useCalendarData = (currentMonth) => {
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Use useMemo to stabilize the currentMonth value
  const stableCurrentMonth = useMemo(() => {
    return currentMonth || new Date();
  }, [currentMonth]);

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await getCalenderEventList({ date: stableCurrentMonth });
      // Ensure response is always an array
      setTableData(Array.isArray(response) ? response : []);
    } catch (error) {
      // Set empty array on error to prevent undefined errors
      setTableData([]);
      // Only show toast for non-404 errors (404 might be expected in some cases)
      if (error?.response?.status !== 404) {
        toast.error('Failed to fetch calendar data');
      }
    } finally {
      setIsLoading(false);
    }
  }, [stableCurrentMonth]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchData();
    }, 500); // debounce delay of 500 milliseconds

    return () => clearTimeout(timeout);
  }, [fetchData]);

  const updateTablesWithReminders = (newReminder, selectedCell) => {
    if (!newReminder || !selectedCell?.date) {
      fetchData();
      return;
    }

    const updatedData = tableData.map((item) => {
      if (item.date === selectedCell.date) {
        return {
          ...item,
          reminders: [newReminder, ...item.reminders],
        };
      }
      return item;
    });

    setTableData(updatedData);
  };

  return {
    tableData,
    isLoading,
    fetchData,
    updateTablesWithReminders,
  };
};

export default useCalendarData;